import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import CustomToolTip from '../_tooltip';
import { colourPalette, tickValues, metricLegend } from '../_base';
import { useSelector } from 'react-redux';
import { e4Format, e4Formats } from 'helpers/dates';

const Chart = ({ data, axis, item, id }) => {
    const values = data[0].data;
    const [legend1, setLegend1] = React.useState('Series 11');
    const [legend2, setLegend2] = React.useState('Series 2');
    const [bottomTicks, setBottomTicks] = React.useState([]);
    const [leftTicks, setLeftTicks] = React.useState([]);
    const [leftTicksExtra, setLeftTicksExtra] = React.useState({});

    const metrics = useSelector(state => state.dashboard.metrics);
    const user = useSelector(state => state.user.user);

    React.useEffect(() => {
        const me = document.querySelector(`#${id}`);
        setBottomTicks(tickValues(values, 'x', me.offsetWidth));
    }, [item.w]);

    React.useEffect(() => {
        const me = document.querySelector(`#${id}`);
        let extra = {};
        setLeftTicks(tickValues(values, 'y', me.offsetHeight, true, extra));
        setLeftTicksExtra(extra);
    }, [item.h]);

    React.useEffect(() => {
        if (item?.data) {
            const parsed = JSON.parse(item.data);
            setLegend1(metricLegend(parsed.metric1, metrics, user.currencySymbol, legend1));
            setLegend2(metricLegend(parsed.metric2, metrics, user.currencySymbol, legend2));
        }
    }, [item.data]);

    return (
        <ResponsiveLine
            data={data}
            margin={{ top: 10, right: 60, bottom: 50, left: 60 }}
            xScale={{ type: 'point' }}
            yScale={{ type: 'linear' }}
            curve="monotoneX"
            axisTop={null}
            xFormat={x => e4Format(x, e4Formats.monthShort)}
            axisBottom={
                axis === 'right'
                    ? null
                    : {
                          tickValues: bottomTicks,
                          tickSize: 5,
                          tickPadding: 5,
                          tickRotation: 0,
                          format: x => e4Format(x, e4Formats.monthShort),
                          legend: 'Month',
                          legendOffset: 40,
                          legendPosition: 'middle',
                      }
            }
            axisLeft={{
                tickValues: leftTicks,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                format: x => (leftTicksExtra.format ? leftTicksExtra.format(x) : x),
                legend: `${legend1} ${leftTicksExtra.suffix ?? ''}`,
                legendOffset: -50,
                legendPosition: 'middle',
            }}
            enableGridX={false}
            enableGridY={false}
            colors={colourPalette[axis === 'right' ? 1 : 0]}
            lineWidth={1.2}
            pointSize={8}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={1}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-12}
            useMesh
            tooltip={point => <CustomToolTip point={point} legend={axis === 'right' ? legend2 : legend1} />}
        />
    );
};

export default Chart;
